import { LBInput } from '@linearb/buzz';
import Text from 'components/base/Text';

export const WidgetName = ({ name, setName }) => {
  const MAX_LENGTH = 30;

  return (
    <>
      <Text size='medium' mb='0.5rem' pt='1rem'>
        METRICS NAME
      </Text>
      <Text size='medium' mb='1rem' color='shuttleGray'>
        Name your metric
      </Text>

      <div className='pb-4 pr-20'>
        <LBInput
          data-cy='custom-pm-metric-widget-name-cy'
          width='80%'
          maxLength={MAX_LENGTH}
          value={name}
          onChange={event => setName(event.target.value)}
          data-testid='widget-name-testid'
        />
        <Text mt='0.2rem'>Max length is {MAX_LENGTH} characters</Text>
      </div>
    </>
  );
};
